module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../images/marker.f7ef3d6e.svg";